import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 1,
        minWidth: 0
    },
    previous: {
        pointerEvents: "none",
        position: "absolute",
        left: 0,
        right: 0
    },
    current: {
        maxWidth: "100%",
        minWidth: 0
    }
});
export default stylesheet;
